import * as React from "react";

interface DropdownProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  placeholder: string;
  variant?: "default" | "specs";
}

const Dropdown: React.FC<DropdownProps> = ({
  value,
  onChange,
  options,
  placeholder,
  variant = "default",
}) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className={`w-full ${
      variant === "specs"
        ? "bg-grayTwo text-lg rounded-lg p-2 font-ubuntu"
        : "p-4 border text-lg border-gray-300 rounded-lg font-ubuntu"
    } ${!value ? "text-grayOne" : "text-primary"}`}
  >
    <option value="" disabled hidden>
      {placeholder}
    </option>
    {options.map((option) => (
      <option key={option} value={option} className="text-primary">
        {option}
      </option>
    ))}
  </select>
);

export default Dropdown;
